/**
 * P3-32: Religion 升级按钮（ReligionBtnController / BuildingStackableBtn）。
 */
import { useReligionUpgradeButtonModel } from "./useReligionModel";
import { StackableButton } from "../../components/StackableButton";

interface ReligionUpgradeButtonProps {
  upgradeName: string;
}

export function ReligionUpgradeButton({ upgradeName }: ReligionUpgradeButtonProps) {
  const { snap, modelRef, controller, getTooltip } = useReligionUpgradeButtonModel(upgradeName);

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <StackableButton
      snap={snap}
      controller={controller}
      getModel={() => modelRef.current}
      getTooltip={getTooltip}
    />
  );
}
